import type { ChildDom } from "vanjs-core";
import type { PriceWrapper } from "../billing/prices";
import type { Device } from "../device/device";
import { t } from "../locale";
import { div, label, option, select, span } from "./van-tags";

interface Reactive {
	device: Device;
	isOwner: boolean;
	prices: [string, PriceWrapper][];
}

export const subscriptionField = (reactive: Reactive): ChildDom => {
	const onChangePrice = (e: Event): void => {
		if (!(e.target instanceof HTMLSelectElement)) return;
		reactive.device.Subscription.PriceIds.Current = e.target.value;
	};

	return div(
		{ class: "field" },
		label({ class: "label" }, () => t.device.subscriptionLabel),
		div(
			{ class: "control" },
			div({ class: "select" }, () =>
				select(
					{
						disabled: !reactive.isOwner,
						onchange: onChangePrice,
					},
					reactive.prices.map(([id, price]) =>
						option({
							value: id,
							text: price.name,
						}),
					),
				),
			),
		),
		div(
			{ class: "control" },
			span(
				{
					class: "input is-static",
				},
				() =>
					reactive.prices
						.find(
							([id, _]) =>
								id ===
								reactive.device.Subscription.PriceIds.Current,
						)?.[1]
						.toString() || "",
			),
		),
	);
};
